import { Routes, Route } from 'react-router-dom';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { PageWrapper } from '@/domain/vertraege/pages/PageWrapper';

export function Vertraege() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WithFeatureFlags name="vertraege">
            <PageWrapper />
          </WithFeatureFlags>
        }
      />
    </Routes>
  );
}
